<div class="cm-rgb-curves">
    <div class="cm-curve-toggle">
        <div class="cm-curve-toggle-item cm-rgb" [class.cm-active]="$selectedCurveType() === 'rgb'" (click)="$selectedCurveType.set('rgb')">RGB</div>
        <div class="cm-curve-toggle-item cm-r" [class.cm-active]="$selectedCurveType() === 'r'" (click)="$selectedCurveType.set('r')">R</div>
        <div class="cm-curve-toggle-item cm-g" [class.cm-active]="$selectedCurveType() === 'g'" (click)="$selectedCurveType.set('g')">G</div>
        <div class="cm-curve-toggle-item cm-b" [class.cm-active]="$selectedCurveType() === 'b'" (click)="$selectedCurveType.set('b')">B</div>
    </div>
    <cm-spline-curve
        [controlPoints]="$splineControlPoints()"
        [curvePoints]="$splineCurvePoints()"
        [width]="$width()"
        [height]="$height()"
        [(selectedControlPoint)]="$selectedSplineControlPoint"
        (onSplineClicked)="onControlPointAdded.emit({curve: $selectedCurveType(), point: $event})"
        (onBeginControlPointDrag)="onBeginControlPointDrag.emit()"
        (onControlPointChanged)="onControlPointChanged.emit({curve: $selectedCurveType(), pointId: $event.pointId, point: $event.point})"
        (onEndControlPointDrag)="onEndControlPointDrag.emit()"
    >
        <ng-content cm-background>
            <svg class="cm-background" [attr.viewBox]="'0 0 ' + $width() + ' ' + $height()" [attr.width]="$width()" [attr.height]="$height()">
                <path class="cm-curve" [attr.d]="'M 0 ' + $height() + ' L ' + $width() + ' 0'" stroke="#6e6e6e" stroke-width="0.3" fill="none" />
            </svg>
        </ng-content>
    </cm-spline-curve>
    <div class="cm-coordinates">
        @let selectedPoint = $selectedSplineControlPoint();
        @if (selectedPoint !== undefined) {
            @if ($splineControlPoints()[selectedPoint]; as controlPoint) {
                <div>x: {{ controlPoint.x | number: "1.2-2" }}</div>
                <div>y: {{ controlPoint.y | number: "1.2-2" }}</div>
                @if ($splineControlPoints().length > 2) {
                    <i
                        class="far fa-trash cm-remove"
                        (click)="onControlPointRemoved.emit({curve: $selectedCurveType(), pointId: selectedPoint}); $selectedSplineControlPoint.set(undefined)"
                    ></i>
                }
            }
        }
    </div>
</div>
